import { useRef } from 'react';

import { Check, Link } from '@phosphor-icons/react/dist/ssr';

import { useCopyToClipboard } from '@/utils/useCopyToClipboard';

import * as styles from '../PostActions.css';

interface Props {
  url: string;
  translations?: Record<string, string>;
}

export const CopyLinkButton = ({ url, translations }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { copied, copy } = useCopyToClipboard();

  const label = copied
    ? (translations?.['clipboard.link_copied'] ?? 'Link copied')
    : (translations?.['search.pagination.copy_link'] ?? 'Copy link');

  return (
    <button
      ref={buttonRef}
      type="button"
      className={styles.copyLinkButton}
      onClick={() => copy(url, buttonRef.current?.parentElement)}
    >
      {copied ? <Check size={16} /> : <Link size={16} />}
      <span>{label}</span>
    </button>
  );
};
